const userId = window.Telegram.WebApp.initDataUnsafe.user.id 

// const userId = 2038669608

export default userId